export default __webpack_public_path__ + "static/media/LooLeeBear_03.a9331f44.jpg";